"use strict";

require("core-js/modules/es6.array.filter.js");
var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _get = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _jsxFileName = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Checkbox/lib/Checkbox.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_2189trno9a() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Checkbox/lib/Checkbox.js";
  var hash = "25825771e5d78cbe0c3b327e1edc12e0a83fa435";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Checkbox/lib/Checkbox.js",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 16
        },
        end: {
          line: 173,
          column: 1
        }
      },
      "1": {
        start: {
          line: 36,
          column: 14
        },
        end: {
          line: 41,
          column: 15
        }
      },
      "2": {
        start: {
          line: 52,
          column: 10
        },
        end: {
          line: 57,
          column: 11
        }
      },
      "3": {
        start: {
          line: 59,
          column: 10
        },
        end: {
          line: 64,
          column: 11
        }
      },
      "4": {
        start: {
          line: 102,
          column: 10
        },
        end: {
          line: 104,
          column: 11
        }
      },
      "5": {
        start: {
          line: 175,
          column: 23
        },
        end: {
          line: 181,
          column: 1
        }
      },
      "6": {
        start: {
          line: 187,
          column: 36
        },
        end: {
          line: 195,
          column: 3
        }
      },
      "7": {
        start: {
          line: 188,
          column: 4
        },
        end: {
          line: 190,
          column: 5
        }
      },
      "8": {
        start: {
          line: 189,
          column: 6
        },
        end: {
          line: 189,
          column: 18
        }
      },
      "9": {
        start: {
          line: 191,
          column: 4
        },
        end: {
          line: 194,
          column: 6
        }
      },
      "10": {
        start: {
          line: 198,
          column: 4
        },
        end: {
          line: 198,
          column: 17
        }
      },
      "11": {
        start: {
          line: 199,
          column: 4
        },
        end: {
          line: 203,
          column: 6
        }
      },
      "12": {
        start: {
          line: 206,
          column: 25
        },
        end: {
          line: 217,
          column: 3
        }
      },
      "13": {
        start: {
          line: 207,
          column: 44
        },
        end: {
          line: 207,
          column: 54
        }
      },
      "14": {
        start: {
          line: 209,
          column: 4
        },
        end: {
          line: 216,
          column: 6
        }
      },
      "15": {
        start: {
          line: 210,
          column: 24
        },
        end: {
          line: 212,
          column: 7
        }
      },
      "16": {
        start: {
          line: 214,
          column: 8
        },
        end: {
          line: 214,
          column: 69
        }
      },
      "17": {
        start: {
          line: 220,
          column: 31
        },
        end: {
          line: 220,
          column: 41
        }
      },
      "18": {
        start: {
          line: 221,
          column: 31
        },
        end: {
          line: 221,
          column: 41
        }
      },
      "19": {
        start: {
          line: 222,
          column: 15
        },
        end: {
          line: 222,
          column: 33
        }
      },
      "20": {
        start: {
          line: 223,
          column: 4
        },
        end: {
          line: 236,
          column: 6
        }
      },
      "21": {
        start: {
          line: 240,
          column: 0
        },
        end: {
          line: 267,
          column: 2
        }
      },
      "22": {
        start: {
          line: 269,
          column: 0
        },
        end: {
          line: 277,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 35,
            column: 14
          },
          end: {
            line: 35,
            column: 15
          }
        },
        loc: {
          start: {
            line: 36,
            column: 14
          },
          end: {
            line: 41,
            column: 15
          }
        },
        line: 36
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 51,
            column: 28
          },
          end: {
            line: 51,
            column: 29
          }
        },
        loc: {
          start: {
            line: 52,
            column: 10
          },
          end: {
            line: 57,
            column: 11
          }
        },
        line: 52
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 58,
            column: 24
          },
          end: {
            line: 58,
            column: 25
          }
        },
        loc: {
          start: {
            line: 59,
            column: 10
          },
          end: {
            line: 64,
            column: 11
          }
        },
        line: 59
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 101,
            column: 10
          },
          end: {
            line: 101,
            column: 11
          }
        },
        loc: {
          start: {
            line: 102,
            column: 10
          },
          end: {
            line: 104,
            column: 11
          }
        },
        line: 102
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 187,
            column: 36
          },
          end: {
            line: 187,
            column: 37
          }
        },
        loc: {
          start: {
            line: 187,
            column: 54
          },
          end: {
            line: 195,
            column: 3
          }
        },
        line: 187
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 197,
            column: 2
          },
          end: {
            line: 197,
            column: 3
          }
        },
        loc: {
          start: {
            line: 197,
            column: 21
          },
          end: {
            line: 204,
            column: 3
          }
        },
        line: 197
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 206,
            column: 25
          },
          end: {
            line: 206,
            column: 26
          }
        },
        loc: {
          start: {
            line: 206,
            column: 31
          },
          end: {
            line: 217,
            column: 3
          }
        },
        line: 206
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 210,
            column: 6
          },
          end: {
            line: 210,
            column: 7
          }
        },
        loc: {
          start: {
            line: 210,
            column: 24
          },
          end: {
            line: 212,
            column: 7
          }
        },
        line: 210
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 213,
            column: 6
          },
          end: {
            line: 213,
            column: 7
          }
        },
        loc: {
          start: {
            line: 213,
            column: 12
          },
          end: {
            line: 215,
            column: 7
          }
        },
        line: 213
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 219,
            column: 2
          },
          end: {
            line: 219,
            column: 3
          }
        },
        loc: {
          start: {
            line: 219,
            column: 11
          },
          end: {
            line: 237,
            column: 3
          }
        },
        line: 219
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 270,
            column: 24
          },
          end: {
            line: 270,
            column: 25
          }
        },
        loc: {
          start: {
            line: 270,
            column: 30
          },
          end: {
            line: 270,
            column: 32
          }
        },
        line: 270
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 39,
            column: 16
          },
          end: {
            line: 40,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 17
          },
          end: {
            line: 39,
            column: 37
          }
        }, {
          start: {
            line: 39,
            column: 41
          },
          end: {
            line: 39,
            column: 77
          }
        }, {
          start: {
            line: 40,
            column: 18
          },
          end: {
            line: 40,
            column: 54
          }
        }],
        line: 39
      },
      "1": {
        loc: {
          start: {
            line: 55,
            column: 12
          },
          end: {
            line: 56,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 13
          },
          end: {
            line: 55,
            column: 33
          }
        }, {
          start: {
            line: 55,
            column: 37
          },
          end: {
            line: 55,
            column: 73
          }
        }, {
          start: {
            line: 56,
            column: 14
          },
          end: {
            line: 56,
            column: 50
          }
        }],
        line: 55
      },
      "2": {
        loc: {
          start: {
            line: 62,
            column: 12
          },
          end: {
            line: 63,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 13
          },
          end: {
            line: 62,
            column: 33
          }
        }, {
          start: {
            line: 62,
            column: 37
          },
          end: {
            line: 62,
            column: 73
          }
        }, {
          start: {
            line: 63,
            column: 14
          },
          end: {
            line: 63,
            column: 50
          }
        }],
        line: 62
      },
      "3": {
        loc: {
          start: {
            line: 101,
            column: 13
          },
          end: {
            line: 101,
            column: 48
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 101,
            column: 20
          },
          end: {
            line: 101,
            column: 48
          }
        }],
        line: 101
      },
      "4": {
        loc: {
          start: {
            line: 188,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 188,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 188
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0],
      "2": [0, 0, 0],
      "3": [0],
      "4": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "25825771e5d78cbe0c3b327e1edc12e0a83fa435"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2189trno9a = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2189trno9a();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Wrapper = (cov_2189trno9a().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-Checkbox"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      label {\n        position: relative;\n        cursor: pointer;\n        padding: 0;\n        display: flex;\n        margin-top: 3px;\n        text-align: left;\n        &:before {\n          content: '';\n          float: left;\n          margin-right: 8px;\n          margin-top: -1px;\n          display: inline-block;\n          vertical-align: text-top;\n          min-width: 15px;\n          height: 15px;\n          background: ", ";\n          border: 2px solid\n            ", ";\n        }\n      }\n      input:disabled ~ label {\n        cursor: default;\n      }\n      input:disabled ~ label {\n        opacity: 0.6;\n      }\n      input:checked ~ label:before {\n        background-color: ", ";\n        border-color: ", ";\n      }\n      input:checked:disabled ~ label:before {\n        background-color: ", ";\n        border: 1px solid ", ";\n      }\n      label:after {\n        content: '';\n        position: relative;\n        display: none;\n      }\n      input:checked ~ label:after {\n        display: block;\n      }\n      input:checked:disabled ~ label:after {\n        left: 6px;\n        width: 5px;\n        height: 120px;\n        border-radius: 2px;\n        border: solid ", ";\n        border-width: 0 3px 3px 0;\n        transform: rotate(45deg);\n      }\n\n      label:after {\n        left: 6px;\n        width: 5px;\n        position: absolute;\n        height: 10px;\n        border-radius: 2px;\n        border: solid white;\n        border-width: 0 3px 3px 0;\n        transform: rotate(45deg);\n      }\n    "])), _stylingConstants.default.color.baseBackground, function (props) {
  cov_2189trno9a().f[0]++;
  cov_2189trno9a().s[1]++;
  return (0, _get.default)(props.theme, 'dashboard.iconColor', (cov_2189trno9a().b[0][0]++, props.theme.checkbox) && (cov_2189trno9a().b[0][1]++, props.theme.checkbox.backgroundColor) || (cov_2189trno9a().b[0][2]++, _stylingConstants.default.color.boxBackground));
}, function (props) {
  cov_2189trno9a().f[1]++;
  cov_2189trno9a().s[2]++;
  return (0, _get.default)(props.theme, 'dashboard.iconColor', (cov_2189trno9a().b[1][0]++, props.theme.checkbox) && (cov_2189trno9a().b[1][1]++, props.theme.checkbox.backgroundColor) || (cov_2189trno9a().b[1][2]++, _stylingConstants.default.color.boxBackground));
}, function (props) {
  cov_2189trno9a().f[2]++;
  cov_2189trno9a().s[3]++;
  return (0, _get.default)(props.theme, 'dashboard.iconColor', (cov_2189trno9a().b[2][0]++, props.theme.checkbox) && (cov_2189trno9a().b[2][1]++, props.theme.checkbox.backgroundColor) || (cov_2189trno9a().b[2][2]++, _stylingConstants.default.color.boxBackground));
}, _stylingConstants.default.color.darkBackground, _stylingConstants.default.color.darkBackground, _stylingConstants.default.color.darkBackground)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      label {\n        ", ";\n\n        position: relative;\n        cursor: pointer;\n        padding: 0;\n        display: flex;\n        margin-top: 3px;\n        text-align: left;\n        &:before {\n          content: '';\n          float: left;\n          margin-right: 8px;\n          margin-top: -1px;\n          display: inline-block;\n          vertical-align: text-top;\n          min-width: 15px;\n          background-color: ", ";\n          border: ", ";\n          border-radius: calc(var(--generalBorderRadius, 12px) / 3);\n          width: var(--checkbox-size);\n          height: var(--checkbox-size);\n        }\n      }\n      input:disabled ~ label {\n        cursor: default;\n      }\n      input:disabled ~ label {\n        opacity: 0.6;\n      }\n      input:checked ~ label:before {\n        border-color: transparent;\n        background-color: ", ";\n      }\n      input:checked:disabled ~ label:before {\n        background-color: ", ";\n        border: 1px solid ", ";\n      }\n      label:after {\n        content: '';\n        position: relative;\n        display: none;\n      }\n      input:checked ~ label:after {\n        display: block;\n      }\n      input:checked:disabled ~ label:after {\n        left: 6px;\n        width: 5px;\n        height: 120px;\n        border-radius: 2px;\n        border: solid ", ";\n        border-width: 0 3px 3px 0;\n        transform: rotate(45deg);\n      }\n\n      label:after {\n        position: absolute;\n        border-radius: 2px;\n        border: solid white;\n        border-width: 0 3px 3px 0;\n\n        width: calc(var(--checkbox-size) / 4);\n        height: calc(var(--checkbox-size) / 2);\n        left: calc(var(--checkbox-size) / 2);\n        top: calc(var(--checkbox-size) / 2);\n        transform: rotate(45deg) translate(-100%, -25%);\n      }\n    "])), function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? (cov_2189trno9a().b[3][0]++, _themeMapper.evolutionTheme.checkbox.size) : _ref$size;
  cov_2189trno9a().f[3]++;
  cov_2189trno9a().s[4]++;
  return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n            --checkbox-size: ", ";\n          "])), size);
}, _themeMapper.evolutionTheme.checkbox.bgColor, _themeMapper.evolutionTheme.checkbox.border, _themeMapper.evolutionTheme.checkbox.checked.bgColor, _stylingConstants.default.color.darkBackground, _stylingConstants.default.color.darkBackground, _stylingConstants.default.color.darkBackground))));
var StyledCheckbox = (cov_2189trno9a().s[5]++, _styledComponents.default.input.attrs({
  className: 'g-Checkbox__checkbox',
  type: 'checkbox'
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  display: none;\n  width: 0;\n"]))));

/**
 * Component to show a basic checkbox with styling
 */
var Checkbox = /*#__PURE__*/function (_Component) {
  function Checkbox(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Checkbox);
    cov_2189trno9a().f[5]++;
    cov_2189trno9a().s[10]++;
    _this = _callSuper(this, Checkbox, [props]);
    (0, _defineProperty2.default)(_this, "toggleCheckboxChange", (cov_2189trno9a().s[12]++, function () {
      cov_2189trno9a().f[6]++;
      var _ref2 = (cov_2189trno9a().s[13]++, _this.props),
        handleCheckboxChange = _ref2.handleCheckboxChange,
        label = _ref2.label;
      cov_2189trno9a().s[14]++;
      _this.setState(function (_ref3) {
        var checked = _ref3.checked;
        cov_2189trno9a().f[7]++;
        cov_2189trno9a().s[15]++;
        return {
          checked: !checked
        };
      }, function () {
        cov_2189trno9a().f[8]++;
        cov_2189trno9a().s[16]++;
        handleCheckboxChange({
          label: label,
          checked: _this.state.checked
        });
      });
    }));
    cov_2189trno9a().s[11]++;
    _this.state = {
      checked: props.checked,
      disabled: props.disabled,
      label: props.label
    };
    return _this;
  }
  (0, _inherits2.default)(Checkbox, _Component);
  return (0, _createClass2.default)(Checkbox, [{
    key: "render",
    value: function render() {
      cov_2189trno9a().f[9]++;
      var _ref4 = (cov_2189trno9a().s[17]++, this.state),
        label = _ref4.label,
        checked = _ref4.checked;
      var _ref5 = (cov_2189trno9a().s[18]++, this.props),
        children = _ref5.children,
        size = _ref5.size;
      var id = (cov_2189trno9a().s[19]++, (0, _utils.uuid)('g-Checkbox'));
      cov_2189trno9a().s[20]++;
      return /*#__PURE__*/_react.default.createElement(Wrapper, {
        size: size,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 224,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(StyledCheckbox, (0, _extends2.default)({
        id: id
      }, this.state, {
        checked: checked,
        onChange: this.toggleCheckboxChange,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 225,
          columnNumber: 9
        }
      })), /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: id,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 231,
          columnNumber: 9
        }
      }, label, children));
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(Checkbox, "getDerivedStateFromProps", (cov_2189trno9a().s[6]++, function (props, state) {
  cov_2189trno9a().f[4]++;
  cov_2189trno9a().s[7]++;
  if (!props.isFullyControlledByProps) {
    cov_2189trno9a().b[4][0]++;
    cov_2189trno9a().s[8]++;
    return null;
  } else {
    cov_2189trno9a().b[4][1]++;
  }
  cov_2189trno9a().s[9]++;
  return _objectSpread(_objectSpread({}, state), {}, {
    checked: props.checked
  });
}));
cov_2189trno9a().s[21]++;
Checkbox.propTypes = {
  /**
   * Method to be called when click over the checkbox
   */
  handleCheckboxChange: _propTypes.default.func,
  /**
   * Label to show along with the checkbox
   */
  label: _propTypes.default.string,
  /**
   * Bool to indicate if the checkbox is disabled
   */
  disabled: _propTypes.default.bool,
  /**
   * Bool to indicate if the checkbox is checked
   */
  checked: _propTypes.default.bool,
  /**
   * Values inside the Checkbox content
   */
  children: _propTypes.default.node,
  /**
   * Bool to indicate if the component is fully render by props value instead of it own state
   */
  isFullyControlledByProps: _propTypes.default.bool,
  /** Size */
  size: _propTypes.default.string
};
cov_2189trno9a().s[22]++;
Checkbox.defaultProps = {
  handleCheckboxChange: function handleCheckboxChange() {
    cov_2189trno9a().f[10]++;
  },
  label: '',
  disabled: false,
  checked: false,
  children: null,
  isFullyControlledByProps: false,
  size: _themeMapper.evolutionTheme.checkbox.size
};
var _default = exports.default = Checkbox;